var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRestrictedInvestor(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    "aria-labelledby": titleId,
    width: 127,
    height: 126,
    viewBox: "0 0 127 126",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.0651 125.845C97.895 125.845 126.13 97.6737 126.13 62.9225C126.13 28.1714 97.895 0 63.0651 0C28.2352 0 0 28.1714 0 62.9225C0 97.6737 28.2352 125.845 63.0651 125.845Z",
    fill: "#242D33"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_999_13181)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.983 37.3621V44.0517C120.983 44.9716 120.23 45.7241 119.311 45.7241H105.931C105.011 45.7241 104.259 44.9716 104.259 44.0517V37.3621C104.259 32.7462 108.005 29 112.621 29C113.189 29 113.741 29.0502 114.277 29.1672H114.31C118.106 29.9533 120.983 33.3148 120.983 37.3621Z",
    fill: "#333F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.983 110.948V117.638C120.983 121.685 118.106 125.047 114.31 125.833C114.31 125.833 114.293 125.833 114.277 125.833C113.741 125.95 113.189 126 112.621 126C108.005 126 104.259 122.254 104.259 117.638V110.948C104.259 110.028 105.011 109.276 105.931 109.276H119.311C120.23 109.276 120.983 110.028 120.983 110.948Z",
    fill: "#333F48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.276 125.833C113.741 125.95 113.189 126 112.621 126H42.3792C37.7633 126 34.0171 122.254 34.0171 117.638V37.3621C34.0171 32.7462 37.7633 29 42.3792 29H112.621C113.189 29 113.741 29.0502 114.276 29.1672C110.48 29.9533 107.603 33.3148 107.603 37.3621V117.638C107.603 121.685 110.48 125.047 114.276 125.833Z",
    fill: "#415360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1899 114.586C93.579 114.586 99.5692 108.596 99.5692 101.207C99.5692 93.8177 93.579 87.8276 86.1899 87.8276C78.8007 87.8276 72.8105 93.8177 72.8105 101.207C72.8105 108.596 78.8007 114.586 86.1899 114.586Z",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1897 107.897C89.8842 107.897 92.8793 104.901 92.8793 101.207C92.8793 97.5123 89.8842 94.5172 86.1897 94.5172C82.4951 94.5172 79.5 97.5123 79.5 101.207C79.5 104.901 82.4951 107.897 86.1897 107.897Z",
    fill: "#415360"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8449 42.3793H60.7759C59.8528 42.3793 59.1035 41.6301 59.1035 40.7069C59.1035 39.7837 59.8528 39.0345 60.7759 39.0345H80.8449C81.7697 39.0345 82.5173 39.7837 82.5173 40.7069C82.5173 41.6301 81.7697 42.3793 80.8449 42.3793Z",
    fill: "#E6E8EC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8965 52.4138H65.793C64.8698 52.4138 64.1206 51.6646 64.1206 50.7414C64.1206 49.8182 64.8698 49.069 65.793 49.069H95.8965C96.8213 49.069 97.5689 49.8182 97.5689 50.7414C97.5689 51.6646 96.8213 52.4138 95.8965 52.4138Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.1033 52.4138H52.4136C51.4905 52.4138 50.7412 51.6646 50.7412 50.7414C50.7412 49.8182 51.4905 49.069 52.4136 49.069H59.1033C60.0265 49.069 60.7757 49.8182 60.7757 50.7414C60.7757 51.6646 60.0265 52.4138 59.1033 52.4138Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8967 59.1034H89.2071C88.2822 59.1034 87.5347 58.3542 87.5347 57.431C87.5347 56.5078 88.2822 55.7586 89.2071 55.7586H95.8967C96.8216 55.7586 97.5692 56.5078 97.5692 57.431C97.5692 58.3542 96.8216 59.1034 95.8967 59.1034Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.5173 59.1034H45.7242C44.801 59.1034 44.0518 58.3542 44.0518 57.431C44.0518 56.5078 44.801 55.7586 45.7242 55.7586H82.5173C83.4421 55.7586 84.1897 56.5078 84.1897 57.431C84.1897 58.3542 83.4421 59.1034 82.5173 59.1034Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8966 65.7931H77.5001C76.5769 65.7931 75.8276 65.0439 75.8276 64.1207C75.8276 63.1975 76.5769 62.4483 77.5001 62.4483H95.8966C96.8214 62.4483 97.569 63.1975 97.569 64.1207C97.569 65.0439 96.8214 65.7931 95.8966 65.7931Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.8104 65.7931H45.7242C44.801 65.7931 44.0518 65.0439 44.0518 64.1207C44.0518 63.1975 44.801 62.4483 45.7242 62.4483H70.8104C71.7336 62.4483 72.4828 63.1975 72.4828 64.1207C72.4828 65.0439 71.7336 65.7931 70.8104 65.7931Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.8966 72.4828H60.7759C59.8528 72.4828 59.1035 71.7335 59.1035 70.8104C59.1035 69.8872 59.8528 69.1379 60.7759 69.1379H95.8966C96.8215 69.1379 97.569 69.8872 97.569 70.8104C97.569 71.7335 96.8215 72.4828 95.8966 72.4828Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0862 72.4828H45.7242C44.801 72.4828 44.0518 71.7335 44.0518 70.8104C44.0518 69.8872 44.801 69.1379 45.7242 69.1379H54.0862C55.0094 69.1379 55.7587 69.8872 55.7587 70.8104C55.7587 71.7335 55.0094 72.4828 54.0862 72.4828Z",
    fill: "current",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.1207 84.1896H47.3966C45.5519 84.1896 44.0518 85.6898 44.0518 87.5345V90.8793C44.0518 92.724 45.5519 94.2241 47.3966 94.2241H64.1207C65.9654 94.2241 67.4655 92.724 67.4655 90.8793V87.5345C67.4655 85.6898 65.9654 84.1896 64.1207 84.1896Z",
    fill: "#E6E8EC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_999_13181"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 97,
    height: 97,
    fill: "white",
    transform: "translate(29 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRestrictedInvestor);
export default __webpack_public_path__ + "static/media/RestrictedInvestor.78b0b1a635d670a4dc2ec3705f8fa3c4.svg";
export { ForwardRef as ReactComponent };